import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { WalletEmailRenderer } from "./email";
import type { WalletBlockProps } from "./types";

export function WalletEditorRenderer(props: WalletBlockProps) {
	return (
		<EmailComponentWrapper shop={props.shop}>
			<WalletEmailRenderer {...props} isEditor />
		</EmailComponentWrapper>
	);
}
